import { StoreProvider } from './StoreProvider';
import { ThemeProvider } from './ThemeProvider';

// Composes all app-level providers.
// Order matters: ThemeProvider outside StoreProvider so the theme is
// available to any provider that might render UI (e.g. PersistGate loader).
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <StoreProvider>{children}</StoreProvider>
    </ThemeProvider>
  );
}
